import { ESuburbanOfferFilter } from '@cian/api-models/common/json_query';
import { Outside } from '@cian/ui-kit';
import { mergeStyles } from '@cian/utils';
import * as React from 'react';

import { POSSESOR_TYPE_NAMES } from '../../constants/posessorType';
import * as stylesCommon from '../FiltersCommon/FiltersCommon.css';
import * as styles from './FilterPosessor.css';

export interface IFilterPosessorProps {
  value: ESuburbanOfferFilter;
  onSelect(posessorType: ESuburbanOfferFilter): void;
}

export interface IFilterPosessorState {
  active: boolean;
}

const POSESSOR_TYPES: { label: string; value: ESuburbanOfferFilter }[] = [
  { label: POSSESOR_TYPE_NAMES[ESuburbanOfferFilter.Any], value: ESuburbanOfferFilter.Any },
  { label: POSSESOR_TYPE_NAMES[ESuburbanOfferFilter.Builder], value: ESuburbanOfferFilter.Builder },
  { label: POSSESOR_TYPE_NAMES[ESuburbanOfferFilter.Individual], value: ESuburbanOfferFilter.Individual },
];

export class FilterPosessor extends React.Component<IFilterPosessorProps, IFilterPosessorState> {
  public state: IFilterPosessorState = {
    active: false,
  };

  public render() {
    const { value } = this.props;
    const { active } = this.state;

    return (
      <Outside onOutside={this.handleOutsideClick}>
        <div {...mergeStyles(stylesCommon['container'], styles['container'])} data-mark="FilterPosessor">
          <button
            {...mergeStyles(stylesCommon['button'], active && stylesCommon['button--active'])}
            title={POSSESOR_TYPE_NAMES[value]}
            onClick={this.handleButtonClick}
          >
            {POSSESOR_TYPE_NAMES[value]}
          </button>
          {active && (
            <div className={styles['dropdown']}>
              <ul className={styles['list']}>
                {POSESSOR_TYPES.map(item => (
                  <li key={`item_${item.label}`}>
                    <button
                      {...mergeStyles(styles['item'], value === item.value && styles['item--active'])}
                      onClick={() => this.handleRoomTypeSelect(item.value)}
                    >
                      {item.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </Outside>
    );
  }

  private handleButtonClick = () => {
    this.setState(state => ({
      active: !state.active,
    }));
  };

  private handleOutsideClick = () => {
    this.setState({
      active: false,
    });
  };

  private handleRoomTypeSelect = (posessorType: ESuburbanOfferFilter) => {
    this.props.onSelect(posessorType);
    this.setState({
      active: false,
    });
  };
}
